<template>
  <v-col md="12" class="px-0 py-0 mx-0 my-0">
      <template v-if="widgets.length > 1">
        <v-sheet light max-width="100%" class="mx-4 my-2" color="#dddae4">
          <v-slide-group
            prev-icon="mdi-arrow-left"
            next-icon="mdi-arrow-right"
          >
              <v-slide-item
                v-for="(widget,n) in old_widgets"
                :key="n"
                class="mx-2"
              >
                <template v-if="widget=='TotalElementos'">
                  <TotalElementos :ref="widget"></TotalElementos>
                </template>
                <template v-else-if="widget=='PorcentajesSentimientos'">
                  <PorcentajesSentimientos :ref="widget" :key="'widget_'+n" @widget_eliminado="delete $refs[widget]"></PorcentajesSentimientos>
                </template>
                <template v-else-if="widget=='Tiempo'">
                  <Tiempo :ref="widget"></Tiempo>
                </template>
              </v-slide-item>
              <v-slide-item class="mx-2">

                <v-card light height="100" width="150">
                  <v-row
                  class="fill-height mt-0"
                  align="center"
                  justify="center">
                    <v-btn
                      @click="showWidgets=true"
                      icon
                    >
                      <v-icon x-large>mdi-plus</v-icon>
                    </v-btn>
                  </v-row>
                </v-card>
              </v-slide-item>
            </v-slide-group>
        </v-sheet>
      </template>

      <template v-else>
        <v-row dense>
          <template v-for="(widget,n) in old_widgets">
            <v-col md="3" style="height:110px;" :key="'col'+n">
              <template v-if="widget=='TotalElementos'">
                <TotalElementos :ref="widget" :key="'widget_'+n" @widget_eliminado="delete $refs[widget]"></TotalElementos>
              </template>
              <template v-else-if="widget=='PorcentajesSentimientos'">
                <PorcentajesSentimientos :ref="widget" :key="'widget_'+n" @widget_eliminado="delete $refs[widget]"></PorcentajesSentimientos>
              </template>
              <template v-else-if="widget=='Tiempo'">
                <Tiempo :ref="widget" :key="'widget_'+n" @widget_eliminado="delete $refs[widget]"></Tiempo>
              </template>
            </v-col>
          </template>
          <v-col md="3" style="height:110px;">
            <v-card light height="100">
              <v-btn
                @click="showWidgets=true"
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </template>
      <v-dialog
        v-model="showWidgets"
        max-width="500"
      >
        <v-card light>
          <v-card-title>
            Widgets
          </v-card-title>
          <v-card-text>
            <v-checkbox
              v-for="w in widgets_todos"
              v-model="actual_widgets"
              :label="w"
              :value="w"
              :key="w"
              hide-details
            ></v-checkbox>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="secondary"
              text
              @click="guardar_widgets"
            >
              Guardar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="showWidgets = false"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-col>
</template>

<script>
import TotalElementos from "@/components/widgets/TotalElementos.vue"
import Tiempo from "@/components/widgets/Tiempo.vue"
import PorcentajesSentimientos from "@/components/widgets/PorcentajesSentimientos.vue"
import { mapActions } from 'vuex';
export default {
  data(){
    return {
     widgets_todos:['TotalElementos','PorcentajesSentimientos','Tiempo'],
     showWidgets: false,
     actual_widgets: [],
     old_widgets: [],
    };
  },
  components:{
    TotalElementos,
    Tiempo,
    PorcentajesSentimientos,
  },
  computed: {
    widgets(){
      return this.$store.state.auth.widgets;
    }
  },
  methods:{
    refrescar(){
      for (var i = 0; i < this.widgets.length; i++) {
        this.$refs[this.widgets[i]][0].getData()
      }
    },
    guardar_widgets(){
      var widgets_borrados = this.old_widgets.filter(x=>!this.actual_widgets.includes(x));
      for (var i = 0; i < widgets_borrados.length; i++) {
        delete this.$refs[widgets_borrados[i]]
      }
      this.setWidgets(this.actual_widgets);
      this.old_widgets = this.actual_widgets;
      this.showWidgets = false;
      setTimeout(this.refrescar, 2000);
    },
    ...mapActions({
      setWidgets: 'auth/setWidgets'
    })
  },
  mounted(){
    this.actual_widgets=this.widgets
    this.old_widgets=this.widgets
  }
}
</script>

<style>
</style>
